"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Services = exports.ServicesWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Label = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eous8jk6"
} : {
  target: "eous8jk6",
  label: "Label"
})("font-size:", _styles.typography.size.s2, "px;line-height:20px;color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.5)' : _styles.color.dark;
}, ";margin-bottom:8px;");
var Attribution = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eous8jk5"
} : {
  target: "eous8jk5",
  label: "Attribution"
})(_styles.text.regular, ";color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.5)' : _styles.color.dark;
}, ";margin-top:2rem;@media (min-width: ", _styles.breakpoints[2], "px){margin-top:0;margin-left:auto;}");
var ServiceLogo = (0, _theming.styled)("a", process.env.NODE_ENV === "production" ? {
  target: "eous8jk4"
} : {
  target: "eous8jk4",
  label: "ServiceLogo"
})(process.env.NODE_ENV === "production" ? {
  name: "of5d56",
  styles: "display:inline-block;transition:all 150ms ease-out;transform:translate3d(0, 0, 0);&:hover{transform:translate3d(0, -2px, 0);}&:active{transform:translate3d(0, 0, 0);}svg{height:20px;width:auto;display:block;transition:all 150ms ease-out;}"
} : {
  name: "of5d56",
  styles: "display:inline-block;transition:all 150ms ease-out;transform:translate3d(0, 0, 0);&:hover{transform:translate3d(0, -2px, 0);}&:active{transform:translate3d(0, 0, 0);}svg{height:20px;width:auto;display:block;transition:all 150ms ease-out;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var ServiceWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eous8jk3"
} : {
  target: "eous8jk3",
  label: "ServiceWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1y9725j",
  styles: "text-align:left;flex:none"
} : {
  name: "1y9725j",
  styles: "text-align:left;flex:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Service = function Service(_ref) {
  var inverse = _ref.inverse,
      label = _ref.label,
      href = _ref.href,
      logo = _ref.logo;
  return /*#__PURE__*/_react["default"].createElement(ServiceWrapper, null, /*#__PURE__*/_react["default"].createElement(Label, {
    inverse: inverse
  }, label), /*#__PURE__*/_react["default"].createElement(ServiceLogo, {
    href: href
  }, logo));
};

var ServicesWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eous8jk2"
} : {
  target: "eous8jk2",
  label: "ServicesWrapper"
})(_styles.pageMargins, ";padding-top:3rem;display:flex;flex-direction:column;align-items:flex-start;@media (min-width: ", _styles.breakpoints[2], "px){flex-direction:row;padding-top:4rem;}");
exports.ServicesWrapper = ServicesWrapper;
var Divider = (0, _theming.styled)("hr", process.env.NODE_ENV === "production" ? {
  target: "eous8jk1"
} : {
  target: "eous8jk1",
  label: "Divider"
})("border:0;width:1px;height:48px;margin:0 15px;background-color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.tr10;
}, ";flex:none;@media (min-width: ", _styles.breakpoints[2], "px){margin:0 30px;}");
var ServicesGroup = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "eous8jk0"
} : {
  target: "eous8jk0",
  label: "ServicesGroup"
})("flex:none;display:flex;align-items:center;@media (min-width: ", _styles.breakpoints[2], "px){margin-right:30px;}");

var Services = function Services(_ref2) {
  var inverse = _ref2.inverse;
  return /*#__PURE__*/_react["default"].createElement(ServicesWrapper, null, /*#__PURE__*/_react["default"].createElement(ServicesGroup, null, /*#__PURE__*/_react["default"].createElement(Service, {
    inverse: inverse,
    label: "Open source software",
    href: "https://storybook.js.org/",
    logo: inverse ? /*#__PURE__*/_react["default"].createElement(_designSystem.Logos.StorybookInverted, {
      title: "Storybook"
    }) : /*#__PURE__*/_react["default"].createElement(_designSystem.Logos.Storybook, {
      title: "Storybook"
    })
  }), /*#__PURE__*/_react["default"].createElement(Divider, {
    inverse: inverse
  }), /*#__PURE__*/_react["default"].createElement(Service, {
    inverse: inverse,
    label: "Maintained by",
    href: "https://www.chromatic.com/storybook?utm_source=storybook_website&utm_medium=footer&utm_campaign=storybook",
    logo: inverse ? /*#__PURE__*/_react["default"].createElement(_designSystem.Logos.ChromaticInverted, {
      title: "Chromatic"
    }) : /*#__PURE__*/_react["default"].createElement(_designSystem.Logos.Chromatic, {
      title: "Chromatic"
    })
  })), /*#__PURE__*/_react["default"].createElement(Attribution, {
    inverse: inverse
  }, "Special thanks to", ' ', /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
    tertiary: true,
    inverse: inverse,
    href: "https://www.netlify.com/",
    rel: "noindex nofollow"
  }, "Netlify"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
    tertiary: true,
    inverse: inverse,
    href: "https://circleci.com/",
    rel: "noindex nofollow"
  }, "CircleCI")));
};

exports.Services = Services;